export const SHORT_DATE_FORMAT = "dd/M/yyyy";
export const LONG_DATE_FORMAT = "d MMMM yyyy";
export const DATE_WITH_TIME_FORMAT = "d MMMM yyyy 'at' p";
